export default __webpack_public_path__ + "static/media/implement-collision-oa.6a788bb1.svg";